import { httpsCallable } from "firebase/functions";
import { functions, functionsNorth } from "@/plugins/firebase.app";

const fns = [
  "harjoituksetList",
  "evyharjoituksetList",
  "ilmoituksetList",

  "ilmoitusGet",
  "ilmoitusDelete",
  "ilmoitusAddFile",
  "ilmoitusDeleteFile",
  "ilmoitusIlmoittautuminen",
  "ilmoitusIlmoittautuminenDelete",
  "ilmoitusIlmoittautuminenDeleteByAnotherUser",

  "ilmoituksetHallitusList",
  "ilmoituksetHallitusListPublished",
  "ilmoitusHallitusGet",
  "ilmoitusHallitusDelete",
  "ilmoitusHallitusAddFile",
  "ilmoitusHallitusDeleteFile",
  "ilmoitusHallitusFiles",
  "ilmoitusHallitusIlmoittautuminen",
  "ilmoitusHallitusIlmoittautuminenDelete",
  "ilmoitusHallitusIlmoittautuminenDeleteByAnotherUser",

  "vaaratilannehavaintoSend",
  "digivihotList",
  "digivihotListPaged",
  "digivihkoGet",
  "digivihkoUpsert",
  "digivihkoDelete",
  "henkilotList",
  "henkiloUpsert",
  "henkiloDelete",
  "usersList",
  "userSave",
  "hourReport",
  "allasDataSave",
  "allasDataList",
  "kalustonhuoltoUpsert",
  "kalustonhuoltoByWeek",
  "digivihkoAddFile",
  "digivihkoDeleteFile",
  "firebaseMessagingAddToken",
  "tiedostopankkiAddFile",
  "tiedostopankkiUpdateFile",
  "tiedostopankkiAddCategory",
  "tiedostopankkiGetFilesAndCategories",

  "tiedostopankkiDeleteFile",
  "tiedostopankkiDeleteCategory",

  "tiedostopankkiHallitusAddFile",
  "tiedostopankkiHallitusUpdateFile",
  "tiedostopankkiHallitusAddCategory",
  "tiedostopankkiHallitusGetFilesAndCategories",
  "tiedostopankkiHallitusDeleteFile",
  "tiedostopankkiHallitusDeleteCategory",
  "tiedostopankkiHallitusAddFileTehtava",

  "tehtavaHallitusFiles",
  "tehtavaHallitusUpsert",
  "tehtavaHallitusList",
  "tehtavaHallitusDelete",
  "tehtavaHallitusAddFile",
  "tehtavaHallitusDeleteFile",
  "tehtavaHallitusGet",
  "tehtavaHallitusKommenttiUpsert",
  "tehtavaHallitusKommenttiDelete",
  "tehtavaHallitusStatus",
  "tehtavaHallitusOrderNumber",

  "listNotifications",
  "markNotificationRead",
  "clearNotifications",
  "sendTestNotificationToSelf",

  "leirikoskiEvents",
  "leirikoskiSensorData",
  "generatePlanContent",
  "harjoitussuunnitelmaAiChatGet",
  "harjoitussuunnitelmaAiChatSend",
  "harjoitussuunnitelmaAiChatReset",
  "harjoitussuunnitelmaGenerateStations",
  "analyzeReceipt",
  "fetchImage",
  "createMemberFormInvitation",
  "vehicleInfoByRegNumber",
  "rescueSheetSearch",
  "rescueDatabaseSync",
  "rescueDatabaseMakes",
  "rescueDatabaseModels",
  "rescueDatabaseVariants",
  "vehicleBatteryLocationAnalysis",
  "recognizePlateNumber",
  "recognizeVakPlate",
];

const fnsv2 = ["ilmoitusUpsert", "ilmoitusHallitusUpsert"];
export default Object.fromEntries([
  ...fns.map((fn) => [fn, httpsCallable(functions, fn)]),
  ...fnsv2.map((fn) => [fn, httpsCallable(functions, fn)]),
  ["hakaAutomation", httpsCallable(functionsNorth, "hakaAutomation")],
]);

/*
export default {
  harjoituksetList: httpsCallable(functions, "harjoituksetList"),
  evyharjoituksetList: httpsCallable(functions, "evyharjoituksetList"),
  ilmoituksetList: httpsCallable(functions, "imoituksetList"),
  ilmoitusUpsert: httpsCallable(functions, "ilmoitusUpsert"),
  ilmoitusIlmoittautuminen: httpsCallable(
    functions,
    "ilmoitusIlmoittautuminen"
  ),
};
*/
